import { inject, Injectable } from '@angular/core';

import { User } from '@shared/services/gql.service';
import { AuthQuery } from '@shared/store/auth/auth.query';
import { Utils } from '@shared/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class ChangeOrderSharedService {
  private authQuery = inject(AuthQuery);

  users = new Map<string, Pick<User, 'email' | 'family_name' | 'given_name'>>();

  userFormatter(sub: string | undefined) {
    const user = this.users.get(sub || '');

    if (user) {
      const isUserAuxAdmin = user.email.includes('@auxili.us');

      if (this.authQuery.isAuxAdmin() || !isUserAuxAdmin) {
        return `${user.given_name} ${user.family_name}`;
      }

      return 'Auxilius Expert';
    }

    return Utils.zeroHyphen;
  }
}
